import { render, staticRenderFns } from "./new-excel-template.vue?vue&type=template&id=600b508c"
import script from "./new-excel-template.vue?vue&type=script&lang=ts"
export * from "./new-excel-template.vue?vue&type=script&lang=ts"
import style0 from "./new-excel-template.vue?vue&type=style&index=0&id=600b508c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports